import { render } from "./UserLogin.vue?vue&type=template&id=3d8b9e50&scoped=true"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"

import "./UserLogin.vue?vue&type=style&index=0&id=3d8b9e50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d8b9e50"

export default script